import { RM02 } from "./RM02";

export const RegionAttendanceReport = {
  sections: [RM02],
};
